import { Component } from '@angular/core';

@Component({
	selector: 'logo-slider-component',
	templateUrl: 'logo-slider.component.html',
	styleUrls: ['./logo-slider.component.scss'],
})
export class LogoSliderComponent {
	public duplicateLogos: Array<string> = ['', ''];
	public logos: Array<string> = [
		'baldemore.jpg',
		'beringen.jpg',
		'digistroom.jpg',
		'hasselt.jpg',
		'kina.jpg',
		'lier.jpg',
		'machelen.jpg',
		'neteland.jpg',
		'noorderkempen.jpg',
		'rupelaar.jpg',
		'sintniklaas.jpg',
		'vilvoorde.jpg',
		'w13.jpg',
		'zuiderkempen.jpg',
	];

	constructor() {}
}
